import _Vue from "vue";

export function BEMPlugin(Vue: typeof _Vue): void {
    Vue.prototype.$bem = function (
        element: string | null = null,
        modifier: string | null = null
    ): string {
        const block = this.$options.name;

        if (element === null && modifier === null) return `${block}`;
        if (element === null) return `${block}--${modifier}`;
        if (modifier === null) return `${block}__${element}`;

        return `${block}__${element}--${modifier}`;
    }
}
